<atlas-item
  interactable
  matTooltip="{{ 'INBOX.HEADER.TITLE' | translate }}"
  icon="question_answer"
  (click)="toggle()"
  [badgeContent]="defaultViewId | unreadConversationsCount | async"
  [customClass]="(buttonSelected$ | async) || ''"
></atlas-item>
